<!--
 * @Name: EditSingleRole
 * @Description: 个人修改权限
 * @Author: xiadongxue
 * @Date: 2021-10-26 10:53:02
 * @Editors: xiadongxue
-->
<template>
<div class="role-edit-wrap">
    <el-dialog
        v-loading="loading"
        title="用户权限"
        :visible.sync="visible"
        :modal-append-to-body="false"
        @closed="close"
        width="600px">
        <el-form
            label-width="170px"
            ref="form"
            :model="form"
            :rules="roleRules">
            <el-form-item
                prop="projectId"
                label="子系统">
                <el-select
                    :disabled="!batch"
                    size="small"
                    @change="changeProject"
                    v-model="form.projectId">
                    <el-option
                        v-for="item in projectList"
                        :key="item.projectId"
                        :value="item.projectId"
                        :label="item.projectName" />
                </el-select>
            </el-form-item>
            <el-form-item
                v-show="showRole"
                prop="roleIds"
                label="角色">
                <el-select
                    filterable
                    multiple
                    size="small"
                    @change="roleDetail"
                    v-model="form.roleIds">
                    <el-option
                        v-for="item in roleList"
                        :key="item.roleId"
                        :value="item.roleId"
                        :label="item.roleName" />
                </el-select>
            </el-form-item>
            <div v-show="showRole">
                <el-form-item
                v-if="visible"
                prop="menuIds"
                label="额外权限">
                <select-menu
                    :user="true"
                    :menuList="menuList"
                    :value.sync="form.menuIds"
                    :default="defaultList" />
                </el-form-item>
            </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button
                @click="visible = false"
                size="small">取消</el-button>
            <el-button
                type="danger"
                size="small"
                @click="toSubmit">确定</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import SelectMenu from './SelectMenu.vue'
import {
    addUserPri,
    editUserPri,
    batchAddUserPri,
    getMenuIdByRoleIds
} from '../api'
import {
    simpleFindMenus,
    simpleFindRoles
} from '@/api'
import {
    mapGetters
} from 'vuex'
export default {
    name: 'EditSingleRole',
    props: {
        //表单信息
        data: {
            type: Object,
            default: () => ({})
        },
        //弹窗展示
        show: {
            type: Boolean,
            default: false
        },
        //是否为添加
        add: {
            type: Boolean,
            default: false
        },
        //用户Id
        userId: {
            type: [Number,Array],
            default: 0
        },
        //是否为批量操作
        batch: {
            type: Boolean,
            default: false
        }
    },
    components: {
        SelectMenu
    },
    computed: {
        ...mapGetters(['projectList']),
        showRole() {
            if(this.batch) {
                let item = this.projectList.find(item => item.projectId === this.form.projectId)
                return item && item.roleAppStatus === 0 
            }
            return true
        }
    },
    created() {
        this.form = this.data
        this.visible = this.show
    },
    data() {
        return {
            loading: false,
            form: {},
            roleRules: {
                projectId: [{
                    required: true,
                    message: "请选择",
                    trigger: 'change'
                }],
                roleIds: [{
                    required: true,
                    trigger: 'change',
                    validator: (rule, value, callback) => {
                        if (!this.showRole) {
                            callback();
                        } else {
                            if(value && value.length) {
                                callback();
                            } else {
                                callback(new Error('请选择'));
                            }
                        }
                    }
                }]
            },
            visible: false,
            //角色列表
            roleList: [],
            //菜单列表
            menuList: [],
            //已选择的菜单
            defaultList: []
        }
    },
    methods: {
        //点击确定
        toSubmit() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    //通过校验
                    this.toSave();
                } else {
                    return false;
                }
            });
        },
        //保存
        async toSave() {
            try {
                this.loading = true
                let Fn = this.add ? addUserPri : editUserPri
                if(this.batch) {
                    Fn = batchAddUserPri
                }
                let data = {
                    projectId: this.form.projectId,
                    roleIds: this.form.roleIds,
                    menuIds: this.form.menuIds,
                    ...this.batch ? {
                        userIdList: this.userId
                    } : {
                        userId: this.userId
                    }
                }
                let {
                    code
                } = await Fn(data)
                if (code === 0) {
                    this.$message.success(`${this.add ? '开通' : '修改'}成功`)
                    this.visible = false
                    this.$emit('submit')
                }
                this.loading = false
            } catch (error) {
                this.loading = false
                console.log(error)
            }
        },
        //移除表单项校验结果
        close() {
            this.$emit('update:show', false)
            this.form = this.data
            this.$nextTick(this.$refs['form'].clearValidate)
        },
        changeProject(value) {
            this.form.roleIds = []
            this.form.menuIds = []
            this.menuList = []
            this.roleList = []
            if(this.showRole && (value || value === 0)) {
                this.selectRole(value)
                this.selectMenu(value)
            }
        },
        //子系统角色查询
        async selectRole(value) {
            try {
                let {
                    code,
                    result
                } = await simpleFindRoles({
                    projectId: value
                })
                if (code === 0) {
                    this.roleList = result
                }
            } catch (error) {
                console.log(error)
            }
        },
        //子系统菜单查询
        async selectMenu(value) {
            try {
                let {
                    code,
                    result
                } = await simpleFindMenus({
                    projectId: value
                })
                if (code === 0) {
                    this.menuList = result
                }
            } catch (error) {
                console.log(error)
            }
        },
        //角色下权限详情
        async roleDetail(value) {
            try {
                if (!value.length) {
                    this.defaultList = []
                    this.form.menuIds = []
                }
                let {
                    code,
                    result
                } = await getMenuIdByRoleIds({
                    roleIds: value
                })
                if (code === 0) {
                    this.defaultList = result.rolesMenuIds
                }
            } catch (error) {
                console.log(error)
            }
        }
    },
    watch: {
        data: {
            deep: true,
            handler(newVal) {
                this.form = JSON.parse(JSON.stringify(newVal))
                if (newVal.projectId || newVal.projectId === 0) {
                    this.selectRole(newVal.projectId)
                    this.selectMenu(newVal.projectId)
                    this.roleDetail(newVal.roleIds)
                } else {
                    this.roleList = []
                    this.menuList = []
                }
                if (this.$refs['form']) {
                    this.$nextTick(this.$refs['form'].clearValidate)
                }
            }
        },
        show(newVal) {
            this.visible = newVal
        }
    }
}
</script>

<style lang="scss" scoped>
.role-edit-wrap {

    .el-cascader,
    .el-select,
    .el-input,
    .el-textarea {
        width: 300px;
    }
}
</style>
